<template>
  <div class="relative shadow-md">
    <div class="w-full lg:pt-16 xl:pt-0 pt-12">
      <div class="py-2 bg-gray-250 pl-4">
        <div class="activity flex container md:hidden m-auto flex-wrap">
          <div
            v-for="item in items"
            :key="item.router_name"
            class="nav-item w-full flex justify-start"
          >
            <div
              @click="toggleMenu"
              class="dropdown-trigger flex py-2 mt-2 items-center justify-start no-underline font-semibold text-sm text-gray-800 hover:text-jblue-primary cursor-pointer"
              v-if="item.router_name === $route.name"
            >
              <div class="w-6 h-6 rounded-full flex justify-center items-center mr-2 bg-jblue-primary">
                <i class="text-sm text-gray-300" :class="[`icon-${item.icon}`]"></i>
              </div>
              {{ $t(`messages.general.${item.translate}`) }}
              <span class="pl-2 my-auto text-xl z-0 mb-1">&#x2304;</span>
            </div>
          </div>

          <ul class="has-dropdown menu-wrapper w-full flex flex-col items-start justify-start flex-no-wrap">
            <li
              class="nav-item list-none w-full"
              :class="{'nav-item-active py-2' : item.router_name !== $route.name}"
              v-for="(item, index) in items"
              :key="index"
            >
              <router-link
                :to="item.page"
                v-if="item.router_name !== $route.name"
                class="item-link flex text-sm justify-start items-center font-semibold z-20 group hover:text-jblue-primary"
                :class="$route.name == item.router_name ? 'text-jblue-primary' : 'text-gray-800'"
              >
                <div
                  class="icon-container w-6 h-6 rounded-full flex justify-center items-center mr-2"
                  :class="$route.name == item.router_name ? 'bg-jblue-primary' : 'bg-gray-300'">
                  <i class="text-sm group-hover:text-gray-300" :class="[`icon-${item.icon}`, $route.name == item.router_name ? 'text-gray-300' : 'text-jblue-primary']"></i>
                </div>
                <p>{{ $t(`messages.general.${item.translate}`) }}</p>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="hidden container md:flex flex-no-wrap mx-auto">
          <ul class="w-full flex flex-row items-center justify-center flex-no-wrap">
            <li
              class="nav-item list-none py-3 my-auto px-6"
              v-for="(item, index) in items"
              :key="index"
            >
              <router-link
                :to="item.page"
                class="item-link flex mx-2 text-sm justify-start items-center font-semibold z-20 group hover:text-jblue-primary"
                :class="$route.name == item.router_name ? 'text-jblue-primary' : 'text-gray-800'"
              >
                <div
                  class="icon-container w-8 h-8 rounded-full flex justify-center items-center mr-2"
                  :class="$route.name == item.router_name ? 'bg-jblue-primary' : 'bg-gray-300'">
                  <i class="text-lg group-hover:text-gray-300" :class="[`icon-${item.icon}`, $route.name == item.router_name ? 'text-gray-300' : 'text-jblue-primary']"></i>
                </div>
                <p>{{ $t(`messages.general.${item.translate}`) }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
export default {
  name: "NavActivity",
  data: () => ({
    items: [
      {
        name: "Visitas a tu perfil",
        translate: "visits_to_your_profile",
        page: "/visits",
        icon: 'greeting',
        router_name: "visits"
      },
      {
        name: "Invitaciones",
        translate: "invitations",
        page: "/invitations",
        icon: 'envelope',
        router_name: "invitations"
      },
      {
        name: "Favoritos",
        translate: "favorites",
        page: "/favorites",
        icon: 'fav',
        router_name: "favorites"
      },
      {
        name: "Favoritos reciprocos",
        translate: "reciprocal_favorites",
        page: "/reciprocal-favorites",
        icon: 'compatability',
        router_name: "reciprocal"
      }
    ]
  }),

  methods: {
    toggleMenu(e) {
      const { target } = e;
      if (target.matches(".dropdown-trigger, .dropdown-trigger *")) {
        const element = document.querySelector(".has-dropdown.menu-wrapper");

        element.classList.toggle("active");
      }
    }
  }
};
</script>
<style lang="scss">

.activity .menu-wrapper {
  max-height: 0;
  overflow: hidden;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;

  &.active {
    max-height: 500px;
  }
}

.item-link {
  transition: all .4s ease-in-out;

  &:hover {
    .icon-container {
      background-color: #1C4C91;
    }
  }
}

.bg-gray-250 {
  background-color: #EDF2FF;
}

.nav-item {
  position: relative;
  .router-link-active {
    color: #0669f9 !important;
  }
}
</style>
